export default __webpack_public_path__ + "static/media/settlement.0ed978a7.svg";